import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import classNames from 'classnames';

const useStyles = makeStyles({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
});

const CustomFormLabel = ({ children, className }) => {
  const classes = useStyles();

  return (
    <FormLabel className={classNames(classes.labelHorizontal, className)}>
      {children}
    </FormLabel>
  );
};

export default CustomFormLabel;
